import { loadStripe } from "@stripe/stripe-js";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";
import { useParams } from "react-router-dom";
import { stripeKey } from "@/Environment";
const stripePromise = loadStripe(stripeKey);

const CheckoutForm = () => {
  const params = useParams();
  const clientSecret = params.client_secret;
  const options = { clientSecret };
  
  return (
    <div id="checkout" className="overflow-auto h-full">
      <EmbeddedCheckoutProvider stripe={stripePromise} options={{ ...options }} key={clientSecret}>
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  );
};

export default CheckoutForm;
